import Vue from "vue";
import Vuex from "vuex";
import User from "@/shared/lib/client-sdk/models/user";
import $ from "jquery";
import SystemPropertiesModule from "@/shared/store/modules/system-properties.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authenticatedUser: null,
    isLoadingAuthenticatedUser: true,
  },
  mutations: {
    setAuthenticatedUser(state, user) {
      state.authenticatedUser = user;
    },
    removeAuthenticatedUser(state) {
      state.authenticatedUser = null;
    },
    isLoadingAuthenticatedUser(state, loading) {
      state.isLoadingAuthenticatedUser = loading;
    },
  },
  actions: {
    refreshAuthenticatedUser(context, callback) {
      context.commit("isLoadingAuthenticatedUser", true);

      User.fetchAuthenticatedUser(
        function (user) {
          context.commit("isLoadingAuthenticatedUser", false);

          if (user && user.isAccountCreated) {
            context.commit("setAuthenticatedUser", user);
          } else {
            context.commit("removeAuthenticatedUser");
          }

          if ($.isFunction(callback)) callback(user);
        }.bind(this)
      );
    },
  },
  modules: {
    systemProperties: SystemPropertiesModule,
  },
});
